/* ===== Подключение компонентов React ===== */

/* ===== Подключение локальной Базы Данных ===== */
import ProblemCards from "../../../data/cardsDb/problemCards";

/* ===== Подключение локальных компонентов ===== */
import Card from "../../ui/Card/CardsSection";

/* ===== Подключение стилей ===== */
import s from "./Problems.module.scss";


function Problems() {
    return (
        <section className={s.problems}>
            <div className={s.neonTop}></div>

            <div className={`container ${s.container}`}>
                <div className={s.titleContiner}>
                    <h5>Наша миссия – снабдить ваш бизнес топливом честно, быстро и надёжно, с<br />
                        индивидуальным подходом к каждому клиенту.
                    </h5>
                </div>
                <div className={s.heading}>
                    <h2>
                        Список распространённых проблем клиентов:
                    </h2>
                    <h5>
                        Мы понимаем проблемы малого и среднего бизнеса при<br />
                        закупке топлива…
                    </h5>
                </div>
                <div className={s.cards}>
                    <Card {...ProblemCards} />
                </div>

                <div className={s.neonDivider}></div>

                <div className={s.footer}>
                    <h5>
                        Крупные игроки не работают с малым бизнесом.<br/>
                        Небольшие трейдеры не обеспечивают стабильный сервис.<br/>
                        В итоге риски - на вашей стороне.
                    </h5>
                </div>
            </div>
        </section>
    )
}

export default Problems;